'use client'

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'
import { User } from '@/lib/types'
import { PaletteIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { ChatKitPageWrapper } from '../_components/chatkit-page-wrapper'
import { ChatKitLoginGate } from '../_components/chatkit-login-gate'
import { getChatKitConstants } from './_const'

interface IDesignClientProps {
  user: User | null
  userApiKey: string
  hasApiKey: boolean
}

/**
 * Client component for Logo Design Agent
 * Handles ChatKit integration and user interactions
 */
export default function DesignClient({
  user,
  userApiKey,
  hasApiKey,
}: IDesignClientProps) {
  const t = useTranslations('design')
  const constants = getChatKitConstants(t)

  if (!user) {
    return (
      <ChatKitLoginGate
        icon={PaletteIcon}
        title="Log in to ideate visuals with AI"
        description="See the Visual Design Agent explore layouts and art direction. Sign in to store iterations, upload references, and export specs."
        redirectUrl="/chatkit/design"
      />
    )
  }

  if (!hasApiKey) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <PaletteIcon />
          </EmptyMedia>
          <EmptyTitle>No API Key</EmptyTitle>
          <EmptyDescription>
            Generate an API key in workspace settings to access the Visual
            Design Agent.
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    )
  }

  return (
    <ChatKitPageWrapper
      user={user}
      userApiKey={userApiKey}
      workflowKey="design"
      constants={constants}
      t={t}
      icon={PaletteIcon}
    />
  )
}
